import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { View, ScrollView, Image, Pressable } from "react-native";
import { PlaceColors } from "./PlaceColors";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceText } from "../components/PlaceText";
import { getTranslatedString } from "./FindifyTranslatedString";
import { makeContentTitle } from "./DetailsHelpers";

export const MakeContentBlock = (rounded: boolean, language: string, content: ContentData, index: number, lIndex: number, findifyDataContext: any, module: string) => {
    if (rounded) {

        return <Pressable
            key={'content_' + index + '_line_' + lIndex}
            onPress={content.action}
        >
            <View
                style={{
                    marginRight: 15,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 100,
                }}
            >
                <View style={{
                    borderRadius: 100,
                    shadowColor: "#000",
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: 0.1,
                    shadowRadius: 6,
                    elevation: 5,
                    backgroundColor: 'white',
                    marginBottom: 8,
                }}>
                    <Image style={{
                        borderRadius: 100,
                        width: 100,
                        height: 100,
                        objectFit: 'cover'
                    }} source={{ uri: content.image }} />
                </View>
                <PlaceText style={{
                    color: PlaceColors(findifyDataContext).text.get(),
                    textAlign: 'center',
                    fontWeight: '600',
                }}>{makeContentTitle(content, module, findifyDataContext)}</PlaceText>
            </View>
        </Pressable>
    }
    return <Pressable
        key={'content_' + index + '_line_' + lIndex}
        onPress={content.action}
    >
        <View
            style={{
                marginRight: 15,
                width: 200,
            }}
        >
            <View style={{
                borderRadius: 16,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: 0.1,
                shadowRadius: 8,
                elevation: 4,
                backgroundColor: 'white',
                marginBottom: 10,
            }}>
                <Image style={{
                    borderRadius: 16,
                    width: 200,
                    height: 110,
                    objectFit: 'cover'
                }} source={{ uri: content.image }} />
            </View>
            <PlaceText
                numberOfLines={2}
                ellipsizeMode="tail"
                style={{
                    color: PlaceColors(findifyDataContext).text.get(),
                    fontWeight: '600',
                    fontSize: 16,
                    marginLeft: 2,
                }}>{makeContentTitle(content, module, findifyDataContext)}</PlaceText>
            {!!content.subtitle && !!getTranslatedString(content.subtitle, findifyDataContext) &&
                <PlaceText
                    numberOfLines={1}
                    ellipsizeMode="tail"
                    style={{
                        color: PlaceColors(findifyDataContext).text.withAlpha(160),

                    }}>
                    {getTranslatedString(content.subtitle, findifyDataContext)}
                </PlaceText>}

        </View>
    </Pressable>


}


export type ContentData = {
    image: string,
    title: any, // Translated String
    subtitle: string,
    action: () => void
}
type ContentsLineArgs = {
    title: string,
    lIndex: number,
    module: string,
    language: string,
    contents: ContentData[],
    viewAllAction: () => void,
    titleColor?: string,
    seeMoreColor?: string,
    rounded?: boolean

}
export const MakeContentsLine = ({
    module,
    language,
    title,
    lIndex,
    contents,
    viewAllAction,
    titleColor,
    seeMoreColor,
    rounded,
}: ContentsLineArgs) => {
    const { t } = useTranslation();
    const findifyDataContext = useContext(FindifyDataContext);
    const bgColor = 'transparent'; // Clean unified background
    return <View
        style={{
            backgroundColor: bgColor,
            marginBottom: 10,
        }}
    >
        <View
            style={{
                paddingTop: 15,
                paddingHorizontal: 15,
                paddingBottom: 5,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            <PlaceText style={{
                color: titleColor ?? PlaceColors(findifyDataContext).text.get(),
                fontWeight: '700',
                fontSize: 20,
            }}>{title}</PlaceText>
            <Pressable onPress={viewAllAction}>
                <View style={{
                    paddingVertical: 4,
                    paddingHorizontal: 10,
                    backgroundColor: (seeMoreColor ?? PlaceColors(findifyDataContext).secondary.get()) + '15',
                    borderRadius: 12,
                }}>
                    <PlaceText style={{
                        color: seeMoreColor ?? PlaceColors(findifyDataContext).secondary.get(),
                        fontWeight: '600',
                        fontSize: 14,
                    }} >{t('place_tab.view_all')}</PlaceText>
                </View>
            </Pressable>
        </View>
        <ScrollView
            bounces={false}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            style={{
                padding: 15,
            }}
            horizontal>
            {contents?.map((content, index) => MakeContentBlock(rounded, language, content, index, lIndex, findifyDataContext, module))}
        </ScrollView>
    </View>

}
